// Mensagens vêm do contato (WhatsApp) e vão para v-html: o texto precisa ser escapado ANTES de virar
// marcação, senão um contato que mande "<img src=x onerror=...>" executa script na tela do operador.
const ENTIDADES = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" };

export function escaparHtml(str) {
  return String(str).replace(/[&<>"']/g, (c) => ENTIDADES[c]);
}

// Formatação do WhatsApp (*negrito*, _itálico_, ~riscado~, ```mono```) sobre o texto já escapado.
// `quebrarLinhas: false` onde o container já usa white-space: pre-wrap (senão cada quebra dobra).
export function formatarMensagem(str, { quebrarLinhas = true } = {}) {
  if (!str) return str;

  const html = escaparHtml(str)
    .replace(/(?:\*)([^*]*)(?:\*)/gm, "<strong>$1</strong>")
    .replace("{#", "<b>Contato: </b>")
    .replace("#}", "")
    .replace(/(?:_)([^_]*)(?:_)/gm, "<i>$1</i>")
    .replace(/(?:~)([^~]*)(?:~)/gm, "<strike>$1</strike>")
    .replace(/(?:```)([^```]*)(?:```)/gm, "<tt>$1</tt>");

  return quebrarLinhas ? html.replace(/\n/g, "<br/>") : html;
}
